import routes from '@/modules/gallery/gallery-routes';
import store from '@/modules/gallery/gallery-store';

export default {
  routes,
  store
};